import type { Dayjs } from "dayjs"

import { caseConverterClient } from "@/api/client"
import type { Embed } from "@/api/embed"
import type { IntegrationKey } from "@/api/integrations"
import type { User } from "@/api/users"

import type { StarterUsagePlan, UsageOverageOption } from "./billing"

export interface Org {
  id: number
  createdAt?: string
  name: string
  subdomain: string
  countryCode: string
  trialEnd: Dayjs | null
  salesforceId?: string
  pricingPlan?: PricingPlan
  importerLimit?: number
  dataRetentionDurationInMinutes: number
  isTest: boolean
  isSelfServe: boolean
  disableDataMask: { [key in IntegrationKey]?: boolean }
  parentOrg?: Org
  logoUrl?: string
  users: User[]

  usagePlan?: StarterUsagePlan
  usageOverageOption?: UsageOverageOption
  stytchSsoConnectionId?: string
  ssoEnforced: boolean

  workflowsBillingCategory?: WorkflowsBillingCategory

  embed?: Embed
}

export const ADMIN_ORG_SUBDOMAIN = "admin"

export function orgIsInternalAdmin(org: Org) {
  return org.subdomain === ADMIN_ORG_SUBDOMAIN
}

export enum PricingPlan {
  Starter = "Starter",
  Pro = "Pro",
  Enterprise = "Enterprise",
}

export enum WorkflowsBillingCategory {
  Legacy = "FileFeedsLegacy",
  Credits = "MultiFileFeedsCredits",
}

export const WORKFLOWS_BILLING_CATEGORY_LABELS: Record<WorkflowsBillingCategory, string> =
  {
    [WorkflowsBillingCategory.Legacy]: "MFF Legacy",
    [WorkflowsBillingCategory.Credits]: "MFF Credits",
  }

export interface UserJwtPayload {
  iss?: string
  // TODO: sub?: string
  user_id?: string
}

export async function generateSandboxUserJWT<TJwtPayload extends UserJwtPayload>(
  jwtPayload: TJwtPayload,
) {
  return caseConverterClient.post<{ jwt: string }>(
    "/api/orgs/generate-sandbox-user-jwt",
    {
      jwtPayload: JSON.stringify(jwtPayload),
    },
  )
}
